import type { StateCreator } from 'zustand';
import CredentialsService from '../../services/credentialsService';
import resetter from '../resetter';
import type { Store } from '../useMainStore';
import { SSOResponse, User } from 'models/User';

export type UserState = {
  user: User | null;
  storeAssociateOptions: {
    label: string;
    value: string;
    id: string;
  }[];
};

export type UserActions = {
  loginAssociate: (user: SSOResponse) => void;
  logoutAssociate: () => void;
};

export type UserSlice = UserState & UserActions;

const initialUserState: UserState = {
  user: null,
  storeAssociateOptions: [],
};

type CreateUserSlice = StateCreator<Store, [], [], UserSlice>;

const generateLoginAssociate = () => {
  return async function loginAssociate(userData: SSOResponse) {
    const { token, refreshToken } = userData;

    await CredentialsService.saveAuthBody({
      token,
      refreshToken,
    });

    return;
  };
};

export const createUserSlice: CreateUserSlice = (set) => {
  resetter.addResetter(() => set(initialUserState));

  return {
    ...initialUserState,

    loginAssociate: generateLoginAssociate(),
    logoutAssociate: () => {
      CredentialsService.removeAuthBody();

      set({ user: null });
    },
  };
};
